import React from "react"
import PropTypes from "prop-types"
import Image from "gatsby-image"
import { FaGithubSquare, FaShareSquare } from "react-icons/fa"

const Project = ({ title, image, description, github, url, stack, index }) => {
  return (
    <article className='project'>
      {image && <Image fluid={image.childImageSharp.fluid} className="project-img" />}
      <div className="project-info">
        <span className="project-number">0{index + 1}</span>
        <h3>{title}</h3>
        <p className='project-desc'>{description}</p>
        <div className='project-stack'>
          {
            stack.map((item)=>{
            return <span key={item.id}>{item.title}</span>
            })
          }
        </div>
        <div className='project-links'>
          <a href={github}><FaGithubSquare className='project-icon'/></a>
          <a href={url}><FaShareSquare className='project-icon'/></a>
          </div>
      </div>
    </article>
  )
}

Project.propTypes = {
  title: PropTypes.string,
  image: PropTypes.object, 
  description: PropTypes.string,
  github: PropTypes.string, 
  url:PropTypes.string, 
  stack:PropTypes.arrayOf(PropTypes.string), 
  index:PropTypes.number,
}

export default Project
